import { Button, Modal, Ref } from "semantic-ui-react";

import { useRef } from "react";
import { useTranslation } from "react-i18next";

import DiscussionThread from "../Discussion/DiscussionThread";

export default function DiscussionModal({ disabled, onClose, title, visibleTo, ...props }) {
	const { t } = useTranslation();
	const ref = useRef();

	const onLoaded = () => {
		if (ref.current) {
			ref.current.scrollTop = ref.current.scrollHeight;
		}
	};

	return (
		<Modal size="small" open onClose={onClose} style={{ overflow: "hidden" }}>
			<Modal.Header>{t("discussion", "Discussion") + " - " + title}</Modal.Header>

			<Ref innerRef={ref}>
				<Modal.Content scrolling>
					{visibleTo.length > 0 && (
						<p style={{ color: "#bbb", marginBottom: 21, textAlign: "center" }}>
							{t("discussionVisibleTo", "This discussion is visible to", {
								organization: visibleTo.join(" & "),
							})}
						</p>
					)}

					<div style={{ maxWidth: 650, margin: "0 auto" }}>
						<DiscussionThread disabled={disabled} {...props} onLoaded={onLoaded} />
					</div>
				</Modal.Content>
			</Ref>
			<Modal.Actions>
				<Button onClick={onClose}>Close</Button>
			</Modal.Actions>
		</Modal>
	);
}
